import React from "react";


import './Slider.css';

import img1 from 'images/hapk1.png';
import img2 from 'images/hapk2.png';
import img3 from 'images/hapk3.png';

export class Slider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imagenes: [],
            imagen: props.imagen
        };
    }

    render() {
        return (
            <div>
              {/*{this.props.imagen ?*/}
                    <div className="slider">
                        <div className="slider-track">
                            {/*<div className="slide"><img src={this.props.imagen} alt="Imagen 1" /></div>*/}
                            <div className="slide"><img src={img1} alt="Imagen 1" /></div>
                            <div className="slide"><img src={img2} alt="Imagen 2" /></div>
                            <div className="slide"><img src={img3} alt="Imagen 3" /></div>
                            <div className="slide"><img src={img1} alt="Imagen 11" /></div>
                            <div className="slide"><img src={img2} alt="Imagen 22" /></div>
                            <div className="slide"><img src={img3} alt="Imagen 33" /></div>
                        </div>
                    </div>
                    {/*: <></>
                }*/}
            </div>
        )
    }
};
export default Slider;
